import React, { useState } from 'react'
import useBasketModel from '@lib/basket-model'
import { addMerchItemToBasket, removeMerchItemFromBasket } from '@lib/spektrix'
import { MinusCircleIcon, PlusCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline'

const MerchandiseBasketSummary = ({
  merchandiseId,
  inBasket,
  isLoading,
  hasStock,
  itemName
}) => {
  const [localLoading, setLocalLoading] = useState(false)
  const basket = useBasketModel()

  const add = () => {
    setLocalLoading(true)
    addMerchItemToBasket(merchandiseId)
      .then(() => {
        // Update global basket state shared across all components
        basket.mutate()
      })
      .catch((error) => {
        console.error('Failed to add item to basket:', error)
      })
      .finally(() => {
        setLocalLoading(false)
      })
  }

  const remove = () => {
    setLocalLoading(true)
    removeMerchItemFromBasket(merchandiseId)
      .then(() => {
        // Update global basket state shared across all components
        basket.mutate()
      })
      .catch((error) => {
        console.error('Failed to remove item from basket:', error)
      })
      .finally(() => {
        setLocalLoading(false)
      })
  }

  const isUpdating = isLoading || localLoading

  if (inBasket > 0) {
    return (
      <div className="flex items-center justify-between w-full">
        <button
          onClick={remove}
          disabled={isUpdating}
          className="disabled:opacity-50 group"
          aria-label="Remove one from basket"
        >
          <MinusCircleIcon className="w-8 h-8 text-blue-600 dark:text-blue-400 group-enabled:hover:bg-blue-600 dark:group-enabled:hover:bg-blue-500 rounded-full group-enabled:hover:text-white transition-colors" />
        </button>
        <div className="flex items-center space-x-1 text-gray-900 dark:text-white">
          {isUpdating ? (
            <ArrowPathIcon className="w-4 h-4 animate-spin mr-2" />
          ) : (
            <>
              <span className="text-sm font-medium">{inBasket} x</span>
              <span className="text-sm">{itemName}</span>
            </>
          )}
        </div>
        <button
          onClick={add}
          disabled={!hasStock || isUpdating}
          className="disabled:opacity-50 group"
          aria-label="Add one to basket"
        >
          <PlusCircleIcon className="w-8 h-8 text-blue-600 dark:text-blue-400 group-enabled:hover:bg-blue-600 dark:group-enabled:hover:bg-blue-500 rounded-full group-enabled:hover:text-white transition-colors" />
        </button>
      </div>
    )
  }

  return (
    <button
      onClick={add}
      disabled={!hasStock || isUpdating}
      className="w-full flex items-center justify-center py-2 px-3 bg-blue-600 text-white font-medium text-sm rounded-md
                 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:text-gray-500
                 dark:bg-blue-500 dark:hover:bg-blue-600
                 dark:disabled:bg-gray-700 dark:disabled:text-gray-400 transition-colors"
    >
      {isUpdating ? (
        <ArrowPathIcon className="w-4 h-4 animate-spin" />
      ) : (
        hasStock ? 'Add to basket' : 'Out of stock'
      )}
    </button>
  )
}

export default MerchandiseBasketSummary
